// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"906":"3d1cdce0","935":"631efba8"}[chunkId] + ".css";
};